import { CloseOutlineIcon, PlusOutlineIcon } from '@carboncopyco/icons';
import { TagsIllustration } from '@carboncopyco/illustrations';
import { ColorHex, InputText, TextBase } from '@carboncopyco/ui';
import { useState } from 'react';
import { useWorkspaceManageTag } from './WorkspaceManageTagContext';

export const WorkspaceManageTagEmpty = () => {
  const { searchKey, setSearchKey, createTag } = useWorkspaceManageTag();
  const [activeInput, setActiveInput] = useState(false);

  return (
    <div className="flex flex-col justify-center items-center w-full">
      {activeInput ? (
        <InputText
          rightElement={
            searchKey?.length > 0 && (
              <div
                className="text-ds-primary-300"
                onClick={() => setSearchKey('')}
              >
                <CloseOutlineIcon />
              </div>
            )
          }
          className="transition-all duration-300"
          autoFocus
          value={searchKey}
          size="xl"
          fullWidth
          placeholder="My Tag"
          onChange={(event) => setSearchKey(event?.target?.value)}
          onKeyUp={({ key }) => {
            key === 'Enter' && createTag();
            key === 'Escape' && setSearchKey('');
          }}
        />
      ) : (
        <div
          className="flex justify-center gap-2 items-center w-full bg-ds-primary-50 h-9 cursor-pointer rounded-lg"
          onClick={() => setActiveInput(true)}
        >
          <PlusOutlineIcon color={ColorHex.primary} />
          <TextBase
            color="text-ds-primary-300"
            label="Create your first tag"
          />
        </div>
      )}

      <div
        className={`truncate flex mt-2 justify-between gap-2 items-center w-full bg-ds-primary-50 h-9 cursor-pointer rounded-lg px-2 ${activeInput && searchKey ? 'visible' : 'invisible'}`}
        onClick={(event) => {
          event.stopPropagation();
          event.preventDefault();
          createTag();
        }}
      >
        <div className="max-w-130 truncate">
          <TextBase
            color="text-ds-primary-300"
            label={`Create tag "${searchKey}"`}
          />
        </div>
        <PlusOutlineIcon color={ColorHex.primary} />
      </div>

      <div className="flex flex-col justify-center gap-2 items-center px-1.5 text-center w-[448px] h-[316px] mb-2.5">
        <TagsIllustration />
        <TextBase
          color="text-ds-natural-600"
          label="There are no tags yet"
        />
        <div className="w-[343px]">
          <TextBase
            color="text-ds-natural-300"
            label="Tags help you organize, search, filter, and share demos and folders in workspace efficiently."
          />
        </div>
      </div>
    </div>
  );
};
